export default "__VITE_ASSET__c1gD9y8Z__"